type DevicePlatform = 'macOS' | 'iOS' | 'Windows' | 'Windows Phone' | 'Android' | 'Linux' | 'Unknown';

type FakePlatformInfo = {
	fakeUserAgentString?: string;
	fakePlatformString?: string;
};

/*
 * iOS Bugfix: iScroll Keyboard position
 * Bugfix for the iOS Web View App where iScroll incorrectly moves the keyboard
 * @see jira.migros.net/browse/PULSWM-3698 & jira.migros.net/browse/PULSWM-3798
 * @see https://stackoverflow.com/questions/24268900/when-using-iscroll-with-inputs-in-ios-safari-the-keyboard-pushes-the-scroller-ab
 */
export const iOSScrollKeyboardPositionFix = () => {
	if (getMobileDevicePlatform() === PLATFORMS.IOS) {
		// use setTimeout so that activeElement returns the next element that has the focus
		setTimeout(() => {
			// only scroll, when the focus is not inside another input field / dropdown when the keyboard closes (= blur event)
			if (
				document.activeElement &&
				document.activeElement.tagName !== 'INPUT' &&
				document.activeElement.tagName !== 'SELECT' &&
				document.activeElement.tagName !== 'TEXTAREA'
			) {
				console.log('iOS Scroll Fix applied');

				window.scrollTo(window.scrollX, window.scrollY);
			}
		}, 0);
	}
};

export const PLATFORMS: { [id: string]: DevicePlatform } = {
	MAC_OS: 'macOS',
	IOS: 'iOS',
	WINDOWS: 'Windows',
	WINDOWS_PHONE: 'Windows Phone',
	ANDROID: 'Android',
	LINUX: 'Linux',
	UNKNOWN: 'Unknown',
};

export const isMobileDevice = (): boolean => {
	return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
};

export const platformDefinitions: Object = {
	[PLATFORMS.MAC_OS]: ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
	[PLATFORMS.WINDOWS]: ['Win32', 'Win64', 'Windows', 'WinCE'],
	[PLATFORMS.IOS]: /iPad|iPhone|iPod/,
	[PLATFORMS.ANDROID]: /android/i,
	[PLATFORMS.LINUX]: /Linux/,
	[PLATFORMS.WINDOWS_PHONE]: /Windows Phone/i,
};

export const getDevicePlatform = ({
	fakeUserAgentString,
	fakePlatformString,
}: FakePlatformInfo = {}): DevicePlatform => {
	try {
		const userAgent: string =
			fakeUserAgentString || window.navigator.userAgent || window.navigator.vendor || (window as any).opera;

		const platform: string = fakePlatformString || window.navigator.platform;
		let os = PLATFORMS.UNKNOWN;

		if (platformDefinitions[PLATFORMS.WINDOWS_PHONE].test(userAgent)) {
			os = PLATFORMS.WINDOWS_PHONE;
		} else if (platformDefinitions[PLATFORMS.MAC_OS].indexOf(platform) !== -1) {
			os = PLATFORMS.MAC_OS;
		} else if (platformDefinitions[PLATFORMS.IOS].test(userAgent) && !(window as any).MSStream) {
			os = PLATFORMS.IOS;
		} else if (platformDefinitions[PLATFORMS.WINDOWS].indexOf(platform) !== -1) {
			os = PLATFORMS.WINDOWS;
		} else if (platformDefinitions[PLATFORMS.ANDROID].test(userAgent)) {
			os = PLATFORMS.ANDROID;
		} else if (!os && platformDefinitions[PLATFORMS.LINUX].test(platform)) {
			os = PLATFORMS.LINUX;
		}

		return os || PLATFORMS.UNKNOWN;
	} catch (e) {
		return PLATFORMS.UNKNOWN;
	}
};

export const getMobileDevicePlatform = ({ fakeUserAgentString }: FakePlatformInfo = {}): DevicePlatform => {
	try {
		const userAgent: string = fakeUserAgentString || window.navigator.userAgent;
		let os: DevicePlatform = PLATFORMS.UNKNOWN;

		if (platformDefinitions[PLATFORMS.WINDOWS_PHONE].test(userAgent)) {
			os = PLATFORMS.WINDOWS_PHONE;
		} else if (platformDefinitions[PLATFORMS.IOS].test(userAgent) && !(window as any).MSStream) {
			os = PLATFORMS.IOS;
		} else if (platformDefinitions[PLATFORMS.ANDROID].test(userAgent)) {
			os = PLATFORMS.ANDROID;
		}

		return os;
	} catch (e) {
		return PLATFORMS.UNKNOWN;
	}
};
